"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
const firestore_2 = require("@react-query-firebase/firestore");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/**
 *
 * @param firestore
 * @param uid
 * @returns Devuelve si el paciente tiene una suscripción activa y está tiene gratis la guardia
 */
function useSubscriptionGuardia(firestore, uid) {
    const subscriptionRef = (0, firestore_1.collection)(firestore, `user/${uid}/subscriptions`);
    const subscriptionActiveQuery = (0, firestore_1.query)(subscriptionRef, (0, firestore_1.where)("active", "==", true));
    return (0, firestore_2.useFirestoreQueryData)(keyFactory_1.FirestoreKeys.Guardia({
        name: "SuscriptionGuardia",
        path: `user/${uid}/subscriptions`
    }, [uid]), subscriptionActiveQuery, {}, {
        select: (data) => {
            if (data) {
                const result = data.find((suscriptionActive) => {
                    return suscriptionActive.services?.guardia && suscriptionActive.services.guardia > 0;
                });
                if (result) {
                    return true;
                }
                return false;
            }
        },
    });
}
exports.default = useSubscriptionGuardia;
